import axios from "axios";
import { baseUrl } from "./config";

export const deleteKpi: any = (params:any) => {
    const path = `${baseUrl}/api/kpis/${params.kpiId}`;
    return axios({
      method: 'DELETE',
      url: path,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => response.data.data).catch(err => {
        console.error('error in deleteKpi', err)
    });
};